export const getDefaultValues = (gameCardDetails) => ({
  FootbalopGameCardPostion: gameCardDetails?.FootbalopGameCardPostion || '',
  FootbalopGameCardNation: gameCardDetails?.FootbalopGameCardNation || '',
  FootbalopGameCardName: gameCardDetails?.FootbalopGameCardName || '',
  FootbalopGameCardTeam: gameCardDetails?.FootbalopGameCardTeam || '',
  FootbalopGameCardSeason: gameCardDetails?.FootbalopGameCardSeason || '',
  FootbalopGameCardAttak: gameCardDetails?.FootbalopGameCardAttak || '',
  FootbalopGameCardDefence: gameCardDetails?.FootbalopGameCardDefence || '',
  FootbalopGameCardSpeed: gameCardDetails?.FootbalopGameCardSpeed || '',
  FootbalopGameCardOverall: gameCardDetails?.FootbalopGameCardOverall || '',
  FootbalopGameCardImages: gameCardDetails?.FootbalopGameCardImages || '',
  FootbalopGameCardPrice: gameCardDetails?.FootbalopGameCardPrice || '',
  FootbalopGameCardStartKit: gameCardDetails?.FootbalopGameCardStartKit || '',
  FootbalopGameCardNumber: gameCardDetails?.FootbalopGameCardNumber || '',
  FootbalopGameCardVersion: gameCardDetails?.FootbalopGameCardVersion || '',
});
